
import Status from 'components/Status'
import React from 'react'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function PreviewTransaction({ tableProps: data, t }) {
  const status =  data?.status
  return (
    <div className="lg:max-w-xl rounded-xl lg:w-full bg-white text-placeholder m-auto px-8 flex flex-col max-h-[500px] " style={{ fontSize: '15px', overflow: 'scroll' }}>
      <div className='my-[10px] flex justify-between items-end'>
        <div className='flex flex-col justify-between'>
          <label className=" text-[#657585] block">{t('transaction.modal.amount_paid')}</label>
          <div className="text-[#657585]" style={{ fontSize: '32px' }}>{data.net_amount}</div>
        </div>
        <p className='p-2'>
          {/* <span className={`p-3 px-5 rounded-lg text-lg capitalize font-medium ${data.status?.toLowerCase() === 'pending' ? 'text-yellow-500 bg-yellow-500 bg-opacity-10' : 'text-green bg-success bg-opacity-10'}`}>{data.status}</span> */}

          {
           status === 'completed' ?<Status text={status} color={'#34C759'} bg={'#34C7591A'} /> : (
            status === 'pending' ? <Status text={status} color={'#F2994A'} bg={'#F2994A1A'} /> :
              <Status text={status} color={'#FF3B30'} bg={'#FF3B301A'} />)
          }
        </p>
      </div>
      <div className=' flex flex-col mb-3 '>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.table.CustomElementRegistry')}</label>
          <p className="w-1/2 text-dark-blue capitalize">{data.username}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Phone</label>
          <p className="w-1/2 text-dark-blue">{data.phone}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.reference')}</label>
          <p className="w-1/2 text-dark-blue">{data.reference}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.payment_method')}</label>
          {/* <p className="w-1/2 text-dark-blue">{`${data.currency_symbol} ${data.balance_before}`}</p> */}
          <p className="w-1/2 text-dark-blue">{data.payment_mode}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.table.date')}</label>
          {/* <p className="w-1/2 text-dark-blue">{`${data.currency_symbol} ${data.balance_before}`}</p> */}
          <p className="w-1/2 text-dark-blue">{data.date}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.table.branch')}</label>
          <p className="w-1/2 text-dark-blue">{data.branch}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.teller')}</label>
          <p className="w-1/2 text-dark-blue">{data.teller}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.table.amount')}</label>
          <p className="w-1/2 text-dark-blue">{data.formatted_gross_amount}</p>
        </div>

        {/* <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
        <label className="w-1/2">{t('transaction.tax_percentage')}</label>
        <p className="w-1/2 text-dark-blue">{data.tax_percentage}</p>
      </div> */}

        {/* <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
        <label className="w-1/2">{t('transaction.discount')}</label>
        <p className="w-1/2 text-dark-blue">{data.given_discount}</p>
      </div> */}

        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Reward earned</label>
          <p className="w-1/2 text-dark-blue">{data.reward_earned}</p>
        </div>

        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Reward redeemed</label>
          <p className="w-1/2 text-dark-blue">{data.reward_used}</p>
        </div>
        <div className={`flex flex-col md:flex-row  py-3  items-center`}>
          <label className="w-1/2">{t('transaction.fee')}</label>
          <p className="w-1/2 text-dark-blue">{data.fee}</p>
        </div>

        {/* <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
        <label className="w-1/2">{t('transaction.table.date')}</label>
        <p className="w-1/2 text-dark-blue">{dayjs(data.created_at).format('DD MMM, YYYY')}</p>
      </div>

      <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
        <label className="w-1/2">{t('transaction.table.status')}</label>
        <p className="w-1/2 text-dark-blue">
          <span className="text-green">{data.status}</span>
        </p>
      </div> */}
      </div>
    </div>
  )
})
